import React__default, { createElement } from 'react';
import { useRouter } from 'next/router';
import { Link as Link$1, Button, IconButton } from '@chakra-ui/react';
import NextLink from 'next/link';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var external = function external(url) {
  if (!url) {
    return false;
  }

  return url.toString().startsWith('http');
};
var LinkingComponent = function LinkingComponent(props) {
  var _newHref;

  var as = props.as,
      href = props.href,
      children = props.children,
      justLink = props.justLink,
      isExternal = props.isExternal,
      isDisabled = props.isDisabled;
  var router = useRouter();
  var newHref = href == null ? void 0 : href.toString();

  if ((_newHref = newHref) == null ? void 0 : _newHref.startsWith('./')) {
    newHref = router.asPath + "/" + newHref.slice(2);
  }

  if (isDisabled) {
    return React__default.createElement(React__default.Fragment, null, children);
  }

  if (href === undefined || !as && external(href) || isExternal) {
    var _ref;

    var _props = _extends({
      href: (_ref = as || href) == null ? void 0 : _ref.toString()
    }, isExternal !== false && {
      target: '_blank',
      rel: 'noopener noreferrer'
    });

    return React__default.createElement("a", Object.assign({}, _props), children);
  }

  return (// TODO: Fix this
    React__default.createElement(NextLink, {
      href: newHref,
      as: as,
      passHref: !justLink
    }, children)
  );
};

var useIsActive = function useIsActive(href) {
  var router = useRouter();

  if (!href) {
    return false;
  }

  return router && router.pathname === href;
};

var asHelper = function asHelper(href, defaultVal) {
  if (defaultVal === void 0) {
    defaultVal = 'a';
  }

  if (!href) {
    return 'button';
  }

  return defaultVal;
};

var Link = function Link(props) {
  var nextAs = props.nextAs,
      href = props.href,
      children = props.children,
      linkProps = props.linkProps,
      justLink = props.justLink,
      isDisabled = props.isDisabled,
      noUnderline = props.noUnderline,
      rest = _objectWithoutPropertiesLoose(props, ["nextAs", "href", "children", "linkProps", "justLink", "isDisabled", "noUnderline"]);

  var isActive = useIsActive(href);
  return createElement(LinkingComponent, Object.assign({
    href: href,
    as: nextAs,
    justLink: justLink,
    isExternal: rest.isExternal,
    isDisabled: isDisabled
  }, linkProps), justLink ? children : createElement(Link$1, Object.assign({}, noUnderline && {
    _hover: {
      textDecoration: 'none !important'
    }
  }, {
    isExternal: rest.isExternal || !nextAs && external(href)
  }, isDisabled && {
    cursor: 'not-allowed',
    opacity: '0.4',
    _hover: {
      textDecoration: 'none'
    }
  }, {
    "aria-current": isActive ? 'page' : undefined
  }, rest), children));
};
var LinkButton = function LinkButton(props) {
  var nextAs = props.nextAs,
      href = props.href,
      children = props.children,
      isDisabled = props.isDisabled,
      linkProps = props.linkProps,
      isExternal = props.isExternal,
      rest = _objectWithoutPropertiesLoose(props, ["nextAs", "href", "children", "isDisabled", "linkProps", "isExternal"]);

  var isActive = useIsActive(href);
  return createElement(LinkingComponent, Object.assign({
    isExternal: isExternal,
    href: href,
    as: nextAs,
    isDisabled: isDisabled
  }, linkProps), createElement(Button, Object.assign({
    as: asHelper(href),
    "aria-current": isActive ? 'page' : undefined,
    isDisabled: isDisabled
  }, rest), children));
};
var LinkIconButton = function LinkIconButton(props) {
  var nextAs = props.nextAs,
      href = props.href,
      children = props.children,
      isDisabled = props.isDisabled,
      linkProps = props.linkProps,
      isExternal = props.isExternal,
      rest = _objectWithoutPropertiesLoose(props, ["nextAs", "href", "children", "isDisabled", "linkProps", "isExternal"]);

  var isActive = useIsActive(href);
  return createElement(LinkingComponent, Object.assign({
    isExternal: isExternal,
    href: href,
    as: nextAs,
    isDisabled: isDisabled
  }, linkProps), createElement(IconButton, Object.assign({
    as: asHelper(href),
    "aria-current": isActive ? 'page' : undefined,
    isDisabled: isDisabled
  }, rest), children));
};

export { Link, LinkButton, LinkIconButton };
//# sourceMappingURL=chakra-next-link.esm.js.map
